import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DashboardFacade } from 'src/app/modules/core/store/dashboard/dashboard.facade';
import { ITotalStatusPeriod } from 'src/app/modules/widget/status-park';

@Component({
  selector: 'app-status-park-table',
  templateUrl: './status-park-table.component.html',
  styleUrls: ['./status-park-table.component.scss'],
})
export class StatusParkTableComponent implements OnChanges {
  @Input() public dataTable: ITotalStatusPeriod[];
  @Input() public showTable: boolean;
  public totalStatusByPeriod: any;
  public periodArray: any[];
  public statusByPorcentagePeriods: any;

  constructor(public dashboardFacade: DashboardFacade) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataTable && changes.dataTable.currentValue) {
      this.totalStatusByPeriod = changes.dataTable.currentValue.status;
      this.periodArray = changes.dataTable.currentValue.periods;
      this.statusByPorcentagePeriods = changes.dataTable.currentValue.statusByPorcentagePeriods;
      this.buildTable();
    }
  }

  public buildTable(): void {
    this.totalStatusByPeriod.forEach((element) => {
      element.porcentageByStatus = [];
      this.periodArray.forEach((period) => {
        const mapped = this.statusByPorcentagePeriods.find((f) => f.statusName === element.statusName && f.periodId === period.periodId);
        element.porcentageByStatus.push(mapped);
      });
    });
  }
}
